import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { formatDateToCyprusFormat, parseCyprusDateFormatToJSDate } from '../utils/date.utils';

@Injectable()
export class CyprusDateAdapter extends NativeDateAdapter {

  override getDateNames(): string[] {
    const dateNames: string[] = [];
    for (let i = 1; i <= 31; i++) {
      dateNames.push(String(i).padStart(2, '0'));
    }
    return dateNames;
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date) {
      return '';
    }

    if (displayFormat === 'input') {
      return formatDateToCyprusFormat(date);
    }

    return super.format(date, displayFormat);
  }

  override parse(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      // Try to parse Cyprus format first (DD-MM-YYYY)
      const cyprusDate = parseCyprusDateFormatToJSDate(value);
      if (cyprusDate) {
        return cyprusDate;
      }

      // Fallback to default parsing
      return super.parse(value);
    }

    return super.parse(value);
  }

  override getFirstDayOfWeek(): number {
    // Monday is the first day of the week in Cyprus
    return 1;
  }
}
